import './InlineFilePreviewListView.css';
import { jsx as d } from "react/jsx-runtime";
import X from "clsx";
import Y, { useState as H, useRef as a, useCallback as z, useEffect as m } from "react";
import Z from "resize-observer-polyfill";
import { I } from "./InlineFilePreviewView-DUO9MJCk.js";
import { getFilePreviewSize as L } from "./InlineFilePreviewView.utils.mjs";
const $ = "_wrapper_mdgey_1", C = {
  wrapper: $
}, ee = ({
  attachments: n,
  numberOfRows: l = 2,
  stopPropagationLongPressOnShowMoreItem: b,
  disableCollapsing: p,
  className: T,
  filePreviewClassName: i,
  ...o
}) => {
  const [y, P] = H(!1), [v, A] = H([]), r = a(), w = a(), k = a(), f = z(
    (e) => {
      for (const u of e) {
        let g = null;
        if (u.contentBoxSize ? g = u.contentBoxSize[0].inlineSize : u.contentRect && (g = u.contentRect.width), g) {
          const c = [], D = parseInt(getComputedStyle(u.target).getPropertyValue("gap").replace("px", ""));
          let M = 1, F = 1, x = 0;
          for (let s = 0; s < n.length; s++) {
            const h = n[s], { wrapperWidth: E } = h.previewImageUrl ? L(o.imageHeight, h.imageRatio) : L(o.imageHeight, 1);
            if (x += E, x + D * (M - 1) > g && (F += 1, x = E, M = 1), F <= l)
              c.push(
                /* @__PURE__ */ d(
                  I,
                  {
                    className: i,
                    ...h,
                    ...o
                  },
                  h.uuid
                )
              ), M += 1;
            else {
              const N = s - 1, V = n[N];
              c.pop();
              const {
                onMouseDown: W,
                onMouseLeave: j,
                onMouseUp: q,
                onTouchStart: G,
                onTouchEnd: J,
                onTouchMove: K,
                ...O
              } = V, Q = b ? {
                onMouseDown: (t) => {
                  t.stopPropagation();
                },
                onMouseLeave: (t) => {
                  t.stopPropagation();
                },
                onMouseUp: (t) => {
                  t.stopPropagation();
                },
                onTouchStart: (t) => {
                  t.stopPropagation();
                },
                onTouchEnd: (t) => {
                  t.stopPropagation();
                },
                onTouchMove: (t) => {
                  t.stopPropagation();
                }
              } : { onMouseDown: W, onMouseLeave: j, onMouseUp: q, onTouchStart: G, onTouchEnd: J, onTouchMove: K };
              c.push(
                /* @__PURE__ */ d(
                  I,
                  {
                    className: i,
                    ...O,
                    ...Q,
                    ...o,
                    showMore: {
                      number: n.length - s
                    }
                  },
                  V.uuid
                )
              );
              break;
            }
          }
          const _ = n.length - c.length - 1;
          (v.length !== c.length || k.current !== _) && (k.current = _, A(c));
        }
      }
    },
    [
      n,
      i,
      l,
      v.length,
      o,
      b
    ]
  ), R = z(
    (e) => {
      w.current = e, f(e);
    },
    [f]
  ), B = a((...e) => R(...e));
  m(() => {
    B.current = (...e) => R(...e);
  }, [R]), m(() => {
    y && (r.current && (r.current.disconnect(), r.current = null), S.current && (r.current = new Z((...e) => B.current(...e)), r.current.observe(S.current)));
  }, [y]);
  const S = a(), U = z(
    (e) => {
      e && (S.current = e, p || P(!0));
    },
    [p]
  );
  return m(() => {
    p ? A(
      n.map((e) => /* @__PURE__ */ d(
        I,
        {
          className: i,
          ...e,
          ...o
        },
        e.uuid
      ))
    ) : l !== void 0 && n.length !== void 0 && w.current && f(w.current);
  }, [n, p, i, l, f, o]), m(() => () => {
    r.current && r.current.disconnect();
  }, []), /* @__PURE__ */ d(
    "div",
    {
      className: X({
        [C.wrapper]: !0,
        [String(T)]: !!T
      }),
      ref: U,
      children: v
    }
  );
}, ue = Y.memo(ee);
export {
  ue as I
};
//# sourceMappingURL=InlineFilePreviewListView-BGso7tb8.js.map
